import { Component, OnInit, ViewChild, Input } from '@angular/core';
// import { FaqService } from '../../../services/faq-services/faq.service';

import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { UtilityServiceService } from '../../../services/utility-services/utility-service.service';
import { TooltipPosition } from '@angular/material/tooltip';
import * as es6printJS from "print-js";
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}
